

function PyromancyTier9DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                This talent is a massive power moment for any Pyromancer. Much like many Tier 9 talents in this overhaul system,
                this is a completely game-changing effect when a player decides to use it.
                <br />
                Notice that this is amplified by the Fire Lord talent, and turns the raw destructive power of
                Fire magic into a powerful zone-control tool for the next 24 hours.
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY CAN'T THE MAGMA BE EXSTINGUISHED?</b>
                <div className="animationFadeIn">
                    This ability is meant to be game-changingly impactful, and letting a Hydromancer's Rain Spell or even
                    their Splash Cantrip extinguish such a powerful effect is both unsatisfying to the Pyromancer, and also
                    cheapens the idea of Magma and lava thematically.
                    <br />
                    Importantly, this also means working with a Hyodromancer ally is much easier, as they can't accidentally exstinguish your Magma.
                    <p />
                    <b>Note:</b> A Cantrip is a basic spell, also known as a level 0 spell, that can be
                    used every turn without expending spell slots.
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    Creating such a devastating effect in potentially a very large area caters to the raw destructive theming of Fire magic.
                    <br />
                    Fireball hurts a lot in D&D, but do you know what hurts even more?
                    <br />
                    A Fireball that leaves a large area too dangerous to traverse for fear or burning to death for the next 24 hours.
                </div>
            </p>
            <br />
        </div>
    )
}

export { PyromancyTier9DesignTemplate };